<div
  role="dialog"
  aria-labelledby="modalAddEditContactTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="modalAddEditContactTitle">{{ 'kanban.funnelForm.title' | translate }}</h5>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="close()"
        ></button>
      </div>

      <div class="modal-body">
        <form [formGroup]="formGroup">
          <div class="row">
            <div class="col-12 mb-3">
              <label class="form-label">
                {{ 'kanban.funnelForm.funnelName' | translate }}
                <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                formControlName="name"
                [placeholder]="'kanban.funnelForm.funnelNamePlaceholder' | translate"
              />
              <field-error-component
                [field]="'name'"
                [label]="'kanban.funnelForm.name' | translate"
                [formGroup]="formGroup"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12 mb-3">
              <label class="form-label">{{ 'kanban.funnelForm.description' | translate }}</label>
              <textarea
                class="form-control scroll"
                formControlName="description"
                [placeholder]="'kanban.funnelForm.descriptionPlaceholder' | translate"
                rows="4"
              ></textarea>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mb-3">
              <label class="form-label">
                {{ 'kanban.funnelForm.category' | translate }}
                <span class="text-danger">*</span>
              </label>
              <mat-select
                class="form-control"
                formControlName="category"
                [placeholder]="'kanban.funnelForm.categoryPlaceholder' | translate"
              >
                <div class="overflow-auto" style="max-height: 220px">
                  @if(funnelCategoryList.length === 0) {
                  <mat-option disabled>{{ 'kanban.funnelForm.noCategoryFound' | translate }}</mat-option>
                  } @for (item of funnelCategoryList; track $index) {
                  <mat-option [value]="item._id">{{ item.name }}</mat-option>
                  }
                </div>
                <div class="d-flex justify-content-end p-1 border-top bg-white">
                  <button
                    class="btn btn-outline-light"
                    (click)="
                      $event.stopPropagation();
                      $event.preventDefault();
                      createCategory()
                    "
                  >
                    <i class="mdi mdi-plus me-1"></i>
                    <span>{{ 'kanban.funnelForm.newCategory' | translate }}</span>
                  </button>
                </div>
              </mat-select>
              <field-error-component
                [field]="'category'"
                [label]="'kanban.funnelForm.category' | translate"
                [formGroup]="formGroup"
              />
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
          <button type="button" class="btn btn-outline-light" (click)="close()">
            {{ 'kanban.funnelForm.close' | translate }}
          </button>
        @if(!isNew) {
          <button type="button" class="btn btn-outline-danger" (click)="delete()">
            {{ 'kanban.funnelForm.remove' | translate }}
          </button>
        }
        <button
          type="button"
          class="btn btn-primary"
          (click)="save()"
          [disabled]="formGroup.invalid || loading"
        >
          @if(isNew) {
            {{ 'kanban.funnelForm.save' | translate }}
          } @else {
            {{ 'kanban.funnelForm.update' | translate }}
          }
        </button>
      </div>
    </div>
  </div>
</div>
